/**
 * User: nir
 * Date: 09/10/2016
 * Time: 15:27
 */

if (window['jQuery']) {
    window.jQuery(function ($) {
        var _data = 'activate',
            _selector = '[data-' + _data + ']',
            _class = 'active',
            activators = $(_selector);
        if (!activators || !activators.length) return;

        function deactivate() {
            activators.each(function (i, e) {
                var activator = $(e),
                    selector = activator ? activator.data(_data) : null;

                if (selector) {
                    $(selector).toggleClass(_class, false);
                }
            });

            return true;
        }

        activators.each(function (i, e) {
            var activator = $(e),
                selector = activator ? activator.data(_data) : null;

            function activate(ev) {
                if (ev && ev.preventDefault) ev.preventDefault();

                $(selector).toggleClass(_class, true);

                return false;
            }

            if (selector) {
                activator.on('click', activate);
            }
        });

        $('body').on('click', deactivate);
    });
}